import { Stack } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';
import { useTableContext } from './useTableContext';

export type ITableHeaderProps = IContainerProps & {
  children?: React.ReactNode;
};

const styles = stylex.create({
  host: {
    minHeight: 40,
    borderColor: colorSchemeTokens.outlineVariant,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    backgroundColor: colorSchemeTokens.surfaceContainerHigh,
  },
  host$tableFirst: {
    backgroundColor: 'unset',
  },
});

export const TableHeader: React.FC<ITableHeaderProps> = (props) => {
  const { sx, children, ...other } = props;
  const context = useTableContext();

  return (
    <Stack
      horizontal
      gap={2}
      sx={[styles.host, !context?.inFlow && styles.host$tableFirst, sx]}
      {...other}
    >
      {children}
    </Stack>
  );
};
